import React from 'react';

import clsx from 'clsx';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

import * as classes from './ConfigurationItem.module.css';

const ConfigurationItem = ({
    onSave,
    onCancel,
    ...props
}) => {
    let { dataItem, selected, ...others } = props;

    if (selected && dataItem.id !== 'input') {
        others['className'] = clsx(others['className'], classes.Selected);
    } else if (dataItem.id === 'input') {
        others['className'] = clsx(others['classname'], classes.Input);
    }

    return (
        <li {...others}>
            <div>
                {
                    dataItem.id === 'input' ?
                        <FormControl className={classes.InputWrapper} variant="outlined" size="small">
                            <TextField
                                className={classes.Textfield}
                                id="outlined-basic"
                                label="Enter"
                                size="small"
                                variant="outlined"
                            />
                            <span role="none" onClick={() => onSave()} className={clsx('material-icons-outlined', classes.Icon)}>
                                done
                            </span>
                            <span role="none" onClick={() => onCancel()} className={clsx('material-icons-outlined', classes.Icon)}>
                                close
                            </span>
                        </FormControl>
                        :
                        <React.Fragment>
                            <Checkbox
                                value="include"
                                checked={selected}
                                name="include"
                                style={{
                                    transform: 'scale(1.5)',
                                    color:     'black'
                                }}
                            />
                            <span className={classes.Text}>
                                {props.dataItem.name}
                            </span>
                        </React.Fragment>
                }
            </div>
        </li>
    );
};

export default ConfigurationItem;
